var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJiaochakou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_3412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.5H3V8.5H0V7.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5H9V8.5H6V7.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 7.5H5V8.5H4V7.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5H11V8.5H10V7.5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0L8.5 4L7.5 4L7.5 -4.37114e-08L8.5 0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7L8.5 10L7.5 10L7.5 7L8.5 7Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13L8.5 16L7.5 16L7.5 13L8.5 13Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5L8.5 6L7.5 6L7.5 5L8.5 5Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11L8.5 12L7.5 12L7.5 11L8.5 11Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0C6 4 4 6 0 6",
    stroke: "#0061F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16C6 12 4 10 0 10",
    stroke: "#0061F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C10 4 12 6 16 6",
    stroke: "#0061F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 12 12 10 16 10",
    stroke: "#0061F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5H16V8.5H12V7.5Z",
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_3412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiaochakou);
export default __webpack_public_path__ + "static/media/jiaochakou.5af2658c6f8eff4dc7c6e55af415d051.svg";
export { ForwardRef as ReactComponent };